import { IntervalType as g } from "@ancon/wildcat-types";
import x from "moment";
import l from "../date/createLocalTimezoneMoment.mjs";
import { OutletMapKeyFormatter as d, OutletTimelineDayCount as k } from "./constants.mjs";
import y from "./getOutletCurrentActiveOperatingHour.mjs";
import D from "./searchNextOpeningMoment.mjs";
import M from "./getTimezoneAdjustedServiceInterval.mjs";
import "../time/getTimeSpanParts.mjs";
import "../date/getTimezoneUtcOffsetDifference.mjs";
import "../date/convertToSpecificTimezone.mjs";
import "./getServiceIntervalTimeSpanMoment.mjs";
const O = {
  0: 127,
  1: 1,
  2: 2,
  3: 4,
  4: 8,
  5: 16,
  6: 32,
  7: 64
  // WEEKDAYS: 31,
  // WEEKENDS: 96,
};
function I(n, e) {
  const t = n.isSame(e, "d"), a = {
    [e.format(d)]: {
      intervals: [],
      exception: null,
      metadata: { dayOfWeek: O[e.isoWeekday()] }
    }
  };
  for (let s = t ? 1 : 0; s < k; s += 1) {
    const i = x(n).add(s, "d");
    a[i.format(d)] = {
      intervals: [],
      exception: null,
      metadata: { dayOfWeek: O[i.isoWeekday()] }
    };
  }
  return a;
}
function S(n, e) {
  const t = l(e.periodFrom), o = l(e.periodTo);
  if (!t.isSame(
    o,
    "d"
  ))
    Object.keys(n).forEach((s) => {
      const i = x(s);
      if (i.isSame(t, "d") || i.isSame(o, "d") || i.isBetween(t, o)) {
        const p = n[s], c = p.exception ? p.exception.position : 0;
        e.position > c && (p.exception = e);
      }
    });
  else {
    const s = t.format(d), i = n[s];
    if (i) {
      const u = i.exception ? i.exception.position : 0;
      e.position > u && (i.exception = e);
    }
  }
}
function T(n, e) {
  Object.keys(n).forEach((t) => {
    const o = n[t], { dayOfWeek: a } = o.metadata, { dayOfWeek: s } = e;
    (a & s) === a && o.intervals.push(e);
  });
}
function W(n, e, t) {
  const o = I(e, t);
  return n.forEach((a) => {
    a.type === g.Exception ? S(o, a) : T(o, a);
  }), o;
}
function E(n, e, t, o) {
  const a = W(
    n,
    t,
    o
  ), s = o.format(d), i = y(
    s,
    a[s],
    o
  ) !== null, u = e;
  let p = null, c = null;
  if (e) {
    const m = t.format(d), f = y(
      m,
      a[m],
      t
    );
    if (f) {
      const r = M(
        m,
        f,
        t.utcOffset()
      );
      c = r.openingTime, p = r.closingTime;
    }
  } else
    c = D(a, t);
  if (!e && !c) {
    const m = n.filter(
      (r) => r.state && l(r.periodTo).isAfter(t)
    ), [f] = m.sort(
      (r, v) => o.valueOf() - (l(r.periodTo).valueOf() - l(v.periodTo).valueOf())
    );
    if (f)
      return E(
        n,
        e,
        l(f.periodTo),
        o
      );
  }
  return { closingTime: p, openingTime: c, openDuringSpecifiedTime: u, openNow: i };
}
export {
  O as DaysOfWeekMap,
  E as default
};
